import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useState,
} from 'react';

import { AssetType } from '../entities/asset-type';
import type { AssetsFilters } from '../entities/assets-filters';

export const AssetsFiltersContext = createContext<
  [AssetsFilters, Dispatch<SetStateAction<AssetsFilters>>]
>(
  // @ts-expect-error - This is a placeholder value that should never be used
  undefined,
);

export function defaultAssetsFilters(): AssetsFilters {
  return {
    date: new Date(),
    assetType: AssetType.CONTAINER,
  };
}

export type AssetsFiltersProviderProps = PropsWithChildren<{}>;

export function AssetsFiltersProvider({
  children,
}: AssetsFiltersProviderProps) {
  const state = useState<AssetsFilters>(defaultAssetsFilters);

  return (
    <AssetsFiltersContext.Provider value={state}>
      {children}
    </AssetsFiltersContext.Provider>
  );
}
